var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenditureClearance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.22 1.336H1.777a.444.444 0 0 0-.444.444v1.482c0 .245.199.444.444.444h12.445a.444.444 0 0 0 .444-.444V1.78a.444.444 0 0 0-.444-.444Z",
    stroke: "#F1F2F6",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.778 3.703H2.223v7.852h11.555V3.703ZM8 14.073v-2.518M1.332 11.555h13.333M9.777 6.375h1.778M9.777 8.445h1.778",
    stroke: "#F1F2F6",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.926 9.188a1.778 1.778 0 1 0 0-3.555 1.778 1.778 0 0 0 0 3.555ZM8.887 14.67c0-.325-.397-.592-.889-.592s-.889.267-.889.593",
    stroke: "#F1F2F6",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenditureClearance);
export default __webpack_public_path__ + "static/media/expenditureClearance.b7adc703dbfa3ec1b655496de3e560dd.svg";
export { ForwardRef as ReactComponent };